<template>
  <div class="coa">
    <SetPopup ref="confirm" />
    <!-- 저장 성공 토스트 (2.8초 자동 사라짐) -->
    <transition name="save-toast-fade">
      <div v-if="toast.show" class="save-toast">
        <v-icon class="save-toast__icon" small>mdi-check-circle-outline</v-icon>
        <span class="save-toast__text">{{ toast.text }}</span>
      </div>
    </transition>
    <!-- [TABEDIT] MSDS 미리보기는 별도 탭(Service.vue)에서 렌더 — 되돌릴 때 v-if 를 msdsPreviewOpen 으로 복구 -->
    <MsdsPreview v-if="false" :lotNo="data.lotNo" :code="displayCodeGrade" :publishing="msdsPublishing" :startInEdit="msdsStartInEdit" :initialReason="msdsReasonForEdit" :preferCurrent="msdsPreferCurrent" :viewOnly="msdsViewOnly" @back="closeMsdsPreview" @requestEdit="editMsds" @publish="publishMsdsFromPreview" @publishEdited="publishEditedFromPreview" @download="downloadIssued(issuedMsds[0])" />
    <!-- LOC 미리보기 — MsdsPreview 를 docType 으로 공용 사용(미리보기/편집 흐름 동일) -->
    <MsdsPreview v-if="locPreviewOpen" docType="LOC" :lotNo="data.lotNo" :code="displayCodeGrade" :publishing="locPublishing" :startInEdit="locStartInEdit" :initialReason="locReasonForEdit" :preferCurrent="locPreferCurrent" :viewOnly="locViewOnly" @back="closeLocPreview" @requestEdit="editLoc" @publish="publishLocFromPreview" @publishEdited="publishEditedLocFromPreview" @download="downloadIssued(issuedLoc[0])" />

    <!-- 수정 사유 입력 모달 -->
    <v-dialog v-model="reasonModalOpen" max-width="660" persistent content-class="reason-modal-dialog">
      <v-card class="reason-modal">
        <v-card-title class="reason-modal__title">
          <v-icon left color="primary">mdi-pencil</v-icon>수정 사유 입력
          <v-spacer />
          <v-btn icon @click="closeReasonModal"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="reason-modal__warn">
            <v-icon left small color="#c77700">mdi-alert-circle-outline</v-icon>
            <span>변경 사유를 먼저 기록해주세요.<br />입력된 사유는 변경 이력에 저장되어 추후 추적 가능합니다.</span>
          </div>
          <div class="reason-modal__label">수정 사유 <span class="reason-modal__req">*</span> <span class="reason-modal__hint">(필수, 최대 500자)</span></div>
          <textarea v-model="reasonText" class="reason-modal__textarea" maxlength="500" placeholder="예: LG 엔솔 요청으로 9번 증발속도 자료 반영 / 5월 10일 합의안 적용"></textarea>
          <div class="reason-modal__counter">{{ reasonText.length }} / 500</div>
        </v-card-text>
        <v-card-actions class="reason-modal__actions">
          <v-spacer />
          <v-btn depressed outlined @click="closeReasonModal">취소</v-btn>
          <v-btn depressed color="primary" :disabled="!reasonText.trim()" @click="startEditWithReason"><v-icon left small>mdi-pencil</v-icon>수정 시작</v-btn>
          <div class="reason-modal__right-space"></div>
        </v-card-actions>
        <div class="reason-modal__bottom-space"></div>
      </v-card>
    </v-dialog>
    <!-- 문서 재발행 확인(경고) 모달 — MSDS/LOC 공용(reissueTarget). 확인 시 미리보기(마스터 재생성본)로 이동 -->
    <v-dialog v-model="reissueModalOpen" max-width="550" persistent content-class="reason-modal-dialog">
      <v-card class="reason-modal">
        <v-card-title class="reason-modal__title">
          <v-icon left color="primary">mdi-refresh</v-icon>{{ reissueTarget }} 재발행 확인
          <v-spacer />
          <v-btn icon @click="reissueModalOpen = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="reason-modal__warn">
            <v-icon left small color="#c77700">mdi-alert-circle-outline</v-icon>
            <span
              >현재 <b>v{{ reissueCurrentVersion }}</b> 문서가 발행되어 있습니다.<br />재발행하면 기존 문서는 사라지며, 새롭게 발행되는 문서만 남습니다.</span
            >
          </div>
          <div class="reason-modal__label">재발행하시겠습니까?</div>
        </v-card-text>
        <v-card-actions class="reason-modal__actions">
          <v-spacer />
          <v-btn depressed outlined :disabled="reissueBusy" @click="reissueModalOpen = false">취소</v-btn>
          <v-btn depressed color="primary" :loading="reissueBusy" @click="confirmReissue"><v-icon left small>mdi-refresh</v-icon>재발행</v-btn>
          <div class="reason-modal__right-space"></div>
        </v-card-actions>
        <div class="reason-modal__bottom-space"></div>
      </v-card>
    </v-dialog>
    <!-- 자동발행 알림(차단=빨강 / 경고=주황) -->
    <v-dialog v-model="msdsAlert.open" max-width="600" content-class="reason-modal-dialog">
      <v-card class="reason-modal">
        <v-card-title class="reason-modal__title">
          <v-icon left :color="msdsAlert.color">{{ msdsAlert.headIcon }}</v-icon
          >{{ msdsAlert.title }}
          <v-spacer />
          <v-btn icon @click="msdsAlert.open = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <p v-if="msdsAlert.lead" class="reason-modal__lead"><v-icon left small color="#2e7d46">mdi-check-circle-outline</v-icon>{{ msdsAlert.lead }}</p>
          <div class="reason-modal__warn" :class="msdsAlert.boxClass">
            <v-icon small :color="msdsAlert.color" class="reason-modal__warn-icon">{{ msdsAlert.boxIcon }}</v-icon>
            <div>
              <p v-for="(m, i) in msdsAlert.causes" :key="i" class="reason-modal__msg" v-html="m"></p>
            </div>
          </div>
          <div v-if="msdsAlert.actions.length" class="reason-modal__guide">
            <p v-for="(a, i) in msdsAlert.actions" :key="i"><v-icon small color="#8a8a8a">mdi-lightbulb-on-outline</v-icon>{{ a }}</p>
          </div>
        </v-card-text>
        <v-card-actions class="reason-modal__actions">
          <v-spacer />
          <v-btn depressed dark :color="msdsAlert.color" @click="msdsAlert.open = false" style="min-width: 96px">확인</v-btn>
          <div class="reason-modal__right-space"></div>
        </v-card-actions>
        <div class="reason-modal__bottom-space"></div>
      </v-card>
    </v-dialog>
    <!-- <h3 class="mb-2">COA 상세</h3> -->
    <div v-show="!anyPreviewOpen" class="filter-box filter-box__row">
      <ul class="filter-list_free" style="width: 90%">
        <li>
          <h4>Lot No</h4>
          <v-text-field outlined dense disabled filled v-model="param.lotNo"></v-text-field>
        </li>
        <li>
          <h4>Code Grade</h4>
          <!-- 표기만 원산지 제한 접미사를 붙인다. 발행·저장에 넘기는 값은 data.code(원본) 그대로다. -->
          <v-text-field outlined dense disabled filled :value="displayCodeGrade"></v-text-field>
        </li>
        <li style="width: 700px">
          <h4>품명</h4>
          <v-text-field outlined dense disabled filled v-model="param.code_title"></v-text-field>
        </li>
        <li style="width: 100px">
          <h4>수량(Qty)</h4>
          <v-text-field outlined dense disabled filled v-model="param.qty"></v-text-field>
        </li>
        <li>
          <h4>제조일</h4>
          <v-text-field outlined dense disabled filled v-model="param.produce_date"></v-text-field>
        </li>
        <li style="width: 180px">
          <h4>수령업체명</h4>
          <v-text-field outlined dense disabled filled v-model="param.pickpart"></v-text-field>
        </li>
      </ul>
      <!-- <v-row class="px-2">
        <v-col cols="12" sm="3">
          <h4>Code Grade</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.code"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <h4>Lot No</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.lotNo"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <h4>수량(Qty)</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.qty"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <h4>제조일</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.produce_date"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-2">
        <v-col cols="12" sm="3">
          <h4>수령업체명</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.pickpart"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="9">
          <h4>품명</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.code_title"
          ></v-text-field>
        </v-col>
      </v-row> -->
    </div>
    <!-- <h3 class="mt-2 mb-2">상세정보</h3> -->
    <!-- <hr class="mb-4" /> -->
    <RealGrid v-show="!anyPreviewOpen" :domName="grid" ref="grid" :settings="settings" :nonePage="true" />
    <!-- 삭제예정_개선업무코드 [ST] -->
    <!-- <div class="filter-box filter-box--row" style="margin-top: 24px">
      <ul class="filter-list03">
        <li>
          <h4 class="">PDF 업로드</h4> -->
    <!-- <hr class="mb-4" /> -->
    <!-- <div class="dp--row">
            <v-text-field
              placeholder="파일을 선택해주세요"
              type="text"
              v-model="file.name"
              outlined
              dense
              disabled
              filled
            />
            <input
              class="d-none"
              ref="uploader"
              type="file"
              @change="onFileChanged"
            />
            <v-btn
              depressed
              class="ml-1 mr-1 btn-choice-file"
              @click="upload"
              :loading="isSelecting"
              >파일선택</v-btn
            >
          </div>
        </li>
      </ul>
      <div class="btn-box">
        <v-btn depressed class="btn-cancle" @click="reset">취소</v-btn>
        <v-btn depressed class="btn-save" @click="save"> 저장 </v-btn>
      </div>
    </div> -->
    <!-- 삭제예정_개선업무코드 [ED] -->
    <!-- 2023.05.22 개선업무코드 [ST] -->
    <!-- 발행 문서 자동 작성 (COA 업로드 / MSDS / LOC) -->
    <div v-show="!anyPreviewOpen" class="issue-doc-panel">
      <div class="issue-doc-head">
        <span class="issue-doc-h">발행 문서 자동 작성</span>
        <span class="issue-doc-badge">NEW</span>
        <span class="issue-doc-sub">· CoA 업로드 및 MSDS · LOC 자동 생성</span>
      </div>
      <div class="issue-doc-cols">
        <!-- COA -->
        <div class="issue-doc-col">
          <div class="col-head"><b>COA</b><span class="col-en">Certificate of Analysis</span><span class="col-note">품질검사 결과 첨부</span></div>
          <div class="coa-upload" :style="{ height: dropAreaHeight }">
            <FileUpload ref="upload1" :readonly="!canWriteCoa" :title="''" :dropAreaHeight="dropAreaHeight" :maxFiles="1" :confirmBeforeDelete="true" @update:files="updateFiles('upload1', $event)" @limit-exceeded="onUploadLimit" @notify="onUploadNotify" @request-delete="onCoaDeleteRequest" :initialFiles="files1" />
          </div>
        </div>

        <!-- MSDS -->
        <div class="issue-doc-col">
          <div class="col-head"><b>MSDS</b><span class="col-en">Material Safety Data Sheet</span><span class="col-note">샘플용 자동 생성 · 양산용 파일 업로드 중 1택</span></div>
          <div v-if="issuedMsds.length && !msdsDeletePending" class="doc-card" :style="{ height: dropAreaHeight }">
            <div class="doc-box">
              <div v-for="doc in issuedMsds" :key="doc.id" class="doc-item">
                <div class="doc-row">
                  <span v-for="b in originBadges(doc.origin)" :key="b.cls" class="doc-badge" :class="b.cls">{{ b.label }}</span>
                  <a class="doc-name" @click="viewMsdsPreview" :title="doc.name">{{ doc.name }}</a>
                </div>
                <div class="doc-meta">작성자 {{ doc.writer }} · {{ doc.date }}</div>
                <div v-if="doc.reason" class="doc-reason" :title="doc.reason"><span class="doc-reason__label">수정사유 :</span> {{ doc.reason }}</div>
              </div>
            </div>
            <div class="doc-actions">
              <v-btn depressed outlined :disabled="!canWriteCoa" @click="editMsds">수정</v-btn>
              <v-btn depressed outlined :disabled="!canWriteCoa" @click="republishMsds">재발행</v-btn>
              <v-btn depressed outlined @click="downloadIssued(issuedMsds[0])">다운로드</v-btn>
              <v-btn depressed outlined class="doc-del" :disabled="!canWriteCoa" @click="deleteMsds">삭제</v-btn>
            </div>
          </div>
          <!-- 양산용 업로드(파일 있음 or 업로드 모드) -->
          <div v-else-if="files2.length || msdsUploadMode" class="msds-upload" :style="{ height: dropAreaHeight }">
            <FileUpload ref="upload2" :readonly="!canWriteCoa" :title="''" :dropAreaHeight="dropAreaHeight" :maxFiles="5" badgeLabel="양산용" :confirmBeforeDelete="true" @update:files="updateFiles('upload2', $event)" @limit-exceeded="onUploadLimit" @notify="onUploadNotify" @request-delete="onMsdsDeleteRequest" @server-files-changed="onMsdsProductionDelete" :initialFiles="files2" />
          </div>
          <!-- 빈 상태: 자동 생성 / 양산용 업로드 선택 (드래그 시 양산용 업로드 처리) -->
          <div v-else class="msds-empty" :class="{ 'is-dragover': msdsDragover }" :style="{ minHeight: dropAreaHeight }" @dragover.prevent="msdsDragover = true" @dragleave.prevent="msdsDragover = false" @drop.prevent="onMsdsEmptyDrop">
            <v-icon size="36" color="#c5cad3">mdi-file-document-outline</v-icon>
            <p>아직 발행된 MSDS 문서가 없습니다</p>
            <div class="msds-empty-actions">
              <v-btn depressed class="btn-save" :disabled="!canWriteCoa" :loading="msdsPublishing" @click="generateMsds"><v-icon left small>mdi-creation</v-icon>MSDS 자동 생성</v-btn>
              <v-btn depressed outlined :disabled="!canWriteCoa" @click="startMsdsUpload"><v-icon left small>mdi-paperclip</v-icon>양산용 업로드</v-btn>
            </div>
            <input ref="msdsFileInput" type="file" accept=".pdf" multiple style="display: none" @change="onMsdsFilePicked" />
          </div>
        </div>

        <!-- LOC -->
        <div class="issue-doc-col">
          <div class="col-head"><b>LOC</b><span class="col-en">Letter of Confirmation</span><span class="col-note">조성 증명서 자동 생성</span></div>
          <div v-if="issuedLoc.length && !locDeletePending" class="doc-card" :style="{ height: dropAreaHeight }">
            <div class="doc-box">
              <div v-for="doc in issuedLoc" :key="doc.id" class="doc-item">
                <div class="doc-row">
                  <span v-for="b in originBadges(doc.origin)" :key="b.cls" class="doc-badge" :class="b.cls">{{ b.label }}</span>
                  <a class="doc-name" @click="viewLocPreview" :title="doc.name">{{ doc.name }}</a>
                </div>
                <div class="doc-meta">작성자 {{ doc.writer }} · {{ doc.date }}</div>
                <div v-if="doc.reason" class="doc-reason" :title="doc.reason"><span class="doc-reason__label">수정사유 :</span> {{ doc.reason }}</div>
              </div>
            </div>
            <div class="doc-actions">
              <v-btn depressed outlined :disabled="!canWriteCoa" @click="editLoc">수정</v-btn>
              <v-btn depressed outlined :disabled="!canWriteCoa" @click="republishLoc">재발행</v-btn>
              <v-btn depressed outlined @click="downloadIssued(issuedLoc[0])">다운로드</v-btn>
              <v-btn depressed outlined class="doc-del" :disabled="!canWriteCoa" @click="deleteLoc">삭제</v-btn>
            </div>
          </div>
          <div v-else class="loc-empty">
            <v-icon size="36" color="#c5cad3">mdi-file-document-outline</v-icon>
            <p>아직 발행된 LOC 문서가 없습니다</p>
            <v-btn depressed class="btn-save" :disabled="!canWriteCoa" :loading="locPublishing" @click="generateLoc"><v-icon left small>mdi-creation</v-icon>LOC 자동 생성</v-btn>
          </div>
        </div>
      </div>
    </div>

    <!-- MSDS 추가 수정 사항 (납품일보 mail_content 연동 · 읽기 전용) -->
    <div v-show="!anyPreviewOpen" class="msds-note-panel">
      <div class="msds-note-head">
        <span class="msds-note-h">MSDS 추가 수정 사항</span>
        <span class="msds-note-sub">(납품일보 연동 · 읽기 전용)</span>
      </div>
      <div class="msds-note-box">
        <ul>
          <li><span class="msds-note-label">요청 자재코드</span>{{ msdsReqCode || '-' }}</li>
          <li><span class="msds-note-label">고객요청 특이사항</span>{{ msdsReqEtc || '-' }}</li>
        </ul>
      </div>
    </div>

    <div v-show="!anyPreviewOpen" class="wrapper">
      <div class="btn-box">
        <v-btn depressed class="btn-cancle" @click="reset">취소</v-btn>
        <v-btn depressed class="btn-save" :disabled="!canWriteCoa" @click="save"> 저장 </v-btn>
      </div>
    </div>

    <!-- 2023.05.22 개선업무코드 [ED] -->
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import { columns, fields, rows, grouping } from '@/assets/grid/coaDetail';
import RealGrid from '@/components/RealGrid.vue';
import _ from 'lodash';
import { coadetail, saveTotalCoaDetail, getIssuedDocs, getIssuedDocFile, deleteIssuedDoc, msdsPublish, msdsPublishEdited, msdsValidate, locValidate, locPublish, locPublishEdited } from 'api/sample/sample';
import { downloadIssuedDoc } from 'api/file';
import { mapMutations, mapGetters } from 'vuex';
import { makeCOASpec } from '@/assets/grid/gridUtill';
import { displayCodeOf } from '@/assets/displayCode';
import SetPopup from '@/components/SetPopup.vue';
import FileUpload from '@/components/FileUpload';
import MsdsPreview from '@/views/document/documentTap/MsdsPreview.vue';

export default {
  props: ['data'],
  computed: {
    ...mapGetters('member', ['canWriteCoa']),
    // 화면 표기값. 원본 코드는 param.code 에 그대로 둔다.
    displayCodeGrade() {
      return displayCodeOf(this.data, this.param.code);
    },
    // 미리보기(MSDS/LOC) 중에는 본문(그리드·패널)을 감춘다
    anyPreviewOpen() {
      // [TABEDIT] MSDS 는 별도 탭에서 열리므로 상세 본문을 가리지 않는다(되돌릴 때 msdsPreviewOpen 조건 복구)
      return this.locPreviewOpen;
    },
    // 미리보기가 '발행본(S3 저장HTML)'을 봐야 하는지 — 삭제 대기 중이면 그 발행본은 없어질 문서이므로
    // 마스터 재생성본을 봐야 한다(안 그러면 삭제 후 자동생성 미리보기에 옛 발행본이 그대로 뜬다).
    msdsPreferCurrent() {
      return this.issuedMsds.length > 0 && !this.msdsForceRegen && !this.msdsDeletePending;
    },
    locPreferCurrent() {
      return this.issuedLoc.length > 0 && !this.locForceRegen && !this.locDeletePending;
    },
    // 재발행 모달: 대상 문서 기준 진행중 상태/현재 버전
    reissueBusy() {
      return this.reissueTarget === 'LOC' ? this.locPublishing : this.msdsPublishing;
    },
    reissueCurrentVersion() {
      const docs = this.reissueTarget === 'LOC' ? this.issuedLoc : this.issuedMsds;
      return docs.length ? docs[0].version : '';
    },
  },
  watch: {
    // ===== [TABEDIT] 시작 — 되돌릴 때 이 watcher 2개 삭제 =====
    // 발행 진행중 표시(저장 버튼 로딩)를 미리보기 탭으로 전달
    msdsPublishing() {
      if (this.msdsPreviewOpen) this.emitMsdsPreview();
    },
    // 저장 완료 등으로 미리보기가 닫히면 탭도 닫는다
    msdsPreviewOpen(v) {
      if (!v) this.$emit('closeMsdsPreview');
    },
    // ===== [TABEDIT] 끝 =====
    param: {
      deep: true,
      handler: function () {
        this.currentPage = 1;
      },
    },
    // 양산용 업로드 파일을 모두 지우면 빈상태(버튼) 화면으로 복귀
    files2(val) {
      if (!val.length && this.msdsUploadMode) this.msdsUploadMode = false;
    },
  },
  data() {
    let coaPdfFiles = Array(5).fill({ name: '' });
    let files = Array(5).fill({ name: '' });

    for (let i = 0; i < 5; i++) {
      let fullPath = this.data['coapdf_path' + (i + 1)];
      let fileName = fullPath ? fullPath.split('/').pop() : '';
      coaPdfFiles[i] = { name: fileName };
    }

    for (let i = 0; i < 5; i++) {
      let fullPath = this.data['msdspdf_path' + (i + 1)];
      let fileName = fullPath ? fullPath.split('/').pop() : '';
      files[i] = { name: fileName };
    }

    return {
      isFetching: false,
      isDataLoaded: false,
      grid: 'coaDetail',
      id: '',
      issuedMsds: [], // issued_document 현재 MSDS(자동생성/발행) — 읽기전용 표시
      issuedLoc: [], // issued_document 현재 LOC(자동생성/편집본) — 읽기전용 표시
      msdsViewOnly: false, // 발행 MSDS 문서 클릭 열람(수정/저장 없이 다운로드+닫기)
      locViewOnly: false, // 발행 LOC 문서 클릭 열람
      locPublishing: false,
      locPreviewOpen: false,
      locStartInEdit: false,
      locReasonForEdit: '',
      locForceRegen: false, // true=발행본 무시하고 마스터에서 재생성(재발행)
      reasonTarget: 'MSDS', // 수정 사유 모달 공용 — 어느 문서의 수정인지
      msdsUploadMode: false, // 양산용 업로드 모드(빈상태 버튼/드래그 → FileUpload 노출)
      msdsPreviewOpen: false, // MSDS 미리보기(전체화면) 표시 여부
      msdsPublishing: false, // 미리보기에서 발행 진행중
      msdsStartInEdit: false, // 미리보기를 편집모드로 바로 시작(사유 모달 경유)
      msdsReasonForEdit: '', // 사유 모달에서 받은 수정 사유
      reasonModalOpen: false, // 수정 사유 입력 모달
      reissueModalOpen: false, // MSDS 재발행 확인(경고) 모달
      msdsForceRegen: false, // 재발행: 미리보기를 '현재 발행본'이 아닌 '마스터 재생성본'으로 강제
      msdsDeletePending: false, // 자동생성 MSDS 삭제 대기(하단 [저장]에서 실제 삭제, [취소]로 원복)
      locDeletePending: false, // 자동생성 LOC 삭제 대기 — MSDS 와 동일 규칙
      msdsReqCode: '', // MSDS 추가 수정 사항 - 요청 자재코드(Produce_Report.request_code)
      msdsReqEtc: '', // MSDS 추가 수정 사항 - 고객요청 특이사항(Produce_Report.request_etc)
      // 재발행 확인 모달 대상 문서(MSDS|LOC) — 모달·확인 로직 공용
      reissueTarget: 'MSDS',
      // 저장 성공 토스트(확인 클릭 없이 2.8초 자동 사라짐)
      toast: { show: false, text: '' },
      toastTimer: null,
      // 자동발행 알림(차단/경고) 다이얼로그
      msdsAlert: { open: false, type: 'block', title: '', lead: '', causes: [], actions: [], color: '#c0392b', headIcon: '', boxIcon: '', boxClass: '' },
      reasonText: '', // 모달 입력값
      msdsDragover: false,
      files1: [],
      files2: [],
      dropAreaHeight: '190px',
      coaPdfFile1: coaPdfFiles[0],
      coaPdfFile2: coaPdfFiles[1],
      coaPdfFile3: coaPdfFiles[2],
      coaPdfFile4: coaPdfFiles[3],
      coaPdfFile5: coaPdfFiles[4],
      msdsFile1: files[0],
      msdsFile2: files[1],
      msdsFile3: files[2],
      msdsFile4: files[3],
      msdsFile5: files[4],
      coaNullCheck: false,
      nullCheck: false,
      settings: {
        columns,
        fields,
        rows,
        height: 585,
        grouping,
        hideCheckBar: true,
        noneNo: true,
      },
      // file: {
      //   name: this.data.coapdf_path ? this.data.coapdf_path.split('/').pop() : '',
      // },
      fileBinary: '',
      param: {
        code: this.data.code ? this.data.code : '',
        lotNo: this.data.lotNo ? this.data.lotNo : '',
        request_name: this.data.request_name ? this.data.request_name : '',
        qty: this.data.qty ? this.data.qty : '',
        produce_date: this.data.produce_date ? this.data.produce_date : '',
        pickpart: this.data.pickpart ? this.pickpart : '',
        code_title: this.data.code_title ? this.data.code_title : '',
      },
      isSelecting: false,
      isSelecting1: false,
      isSelecting2: false,
      isSelecting3: false,
      isSelecting4: false,
      isSelecting5: false,
      currentPage: 1,
    };
  },
  methods: {
    ...mapMutations('popup', ['SET_POPUP', 'SET_POPUP_TEXT']),
    ...mapMutations('menu', ['REMOVE_SELECT_MENU', 'SET_SELECT_MENU_TAB_BY_CODE']),
    ...mapMutations('member', ['SET_USER_INFO']),
    async loadData(v) {
      if (this.isFetching) return;
      this.isFetching = true;

      try {
        if (_.isNumber(v)) {
          this.currentPage = v;
        }
        this.param.lotNo = this.data.lotNo;
        this.param.code = this.data.code;
        const res = await coadetail({
          ...this.param,
          currentPage: this.currentPage,
        });
        this.isDataLoaded = false;

        const data = res.data.data;
        this.param.qty = data.qty;
        this.param.produce_date = data.produce_date;
        this.param.pickpart = data.pickpart;
        this.param.code_title = data.code_title;
        this.param.pt_cd = data.pt_cd;
        this.param.coa_mail_enabled_yn = data.coa_mail_enabled_yn;
        this.param.msds_mail_enabled_yn = data.msds_mail_enabled_yn;
        this.param.out_due_date = data.out_due_date;

        this.coaPdfFile1.name = data.coapdf_path1;
        this.coaPdfFile2.name = data.coapdf_path2;
        this.coaPdfFile3.name = data.coapdf_path3;
        this.coaPdfFile4.name = data.coapdf_path4;
        this.coaPdfFile5.name = data.coapdf_path5;
        this.files1 = [];
        const sortedKeys1 = Object.keys(data)
          .filter(key => key.startsWith('coapdf_path') && data[key] && data[key].trim() !== '')
          .sort((a, b) => {
            const aNum = parseInt(a.replace('coapdf_path', ''), 10);
            const bNum = parseInt(b.replace('coapdf_path', ''), 10);
            return aNum - bNum;
          });
        this.files1 = sortedKeys1.map(key => ({
          name: data[key].replace('/coa_pdf/', ''),
          fromServer: true,
        }));

        this.msdsFile1.name = data.msdspdf_path1;
        this.msdsFile2.name = data.msdspdf_path2;
        this.msdsFile3.name = data.msdspdf_path3;
        this.msdsFile4.name = data.msdspdf_path4;
        this.msdsFile5.name = data.msdspdf_path5;
        this.files2 = [];
        const sortedKeys2 = Object.keys(data)
          .filter(key => key.startsWith('msdspdf_path') && data[key] && data[key].trim() !== '')
          .sort((a, b) => {
            const aNum = parseInt(a.replace('msdspdf_path', ''), 10);
            const bNum = parseInt(b.replace('msdspdf_path', ''), 10);
            return aNum - bNum;
          });
        this.files2 = sortedKeys2.map(key => ({
          name: data[key].replace('/msds_pdf/', ''),
          fromServer: true,
        }));

        // 그리드 먼저 로드 (아래 issued 조회 실패/지연이 그리드에 영향 주지 않도록)
        this.$refs.grid.loadData(data.items);

        // MSDS 추가 수정 사항 = 요청 자재코드 + 고객요청 특이사항(Produce_Report) 읽기전용 로드
        this.msdsReqCode = data.report_request_code || '';
        this.msdsReqEtc = data.request_etc || '';

        // issued_document 현재 MSDS/LOC(자동생성/발행) 읽기전용 로드
        await this.reloadIssuedMsds();
        await this.reloadIssuedLoc();
      } catch (err) {
        this.error = err.message;
      } finally {
        this.isFetching = false;
      }
    },
    reset() {
      this.openPopup('취소하시겠습니까?', true, () => {
        this.REMOVE_SELECT_MENU('coaDetail');
        // this.file = {};
        this.fileBinary = '';
        this.msdsDeletePending = false; // 삭제 대기 원복
        this.locDeletePending = false;
        this.$refs.uploader.value = null;
        this.loadData();
      });
    },
    // 저장 성공 토스트 — 확인 클릭 없이 2.8초 후 자동 사라짐
    showToast(text) {
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toast = { show: true, text };
      this.toastTimer = setTimeout(() => {
        this.toast.show = false;
      }, 2800);
    },
    // width: 기본 300. 문장이 길어 잘리는 안내(삭제 확인 등)는 넓혀서 호출한다.
    openPopup(text, closable, cb, width = 300) {
      this.SET_POPUP({
        title: '알림',
        // height: 150,
        width,
        text,
        closable,
      });
      this.$refs.confirm.openPopup(cb);
    },
    updateFiles(uploadId, files) {
      if (uploadId === 'upload1') {
        this.files1 = files;
      } else if (uploadId === 'upload2') {
        this.files2 = files;
      }
    },
    // 업로드 최대 개수 초과 — 스타일 팝업 안내(초과 시 파일은 하나도 추가하지 않음)
    onUploadLimit(max) {
      this.openPopup(`최대 ${max}개까지만 업로드할 수 있습니다.`, false);
      // MSDS 빈 상태에서 초과 선택으로 업로드 모드만 켜졌던 경우 → 빈 상태(버튼)로 복귀
      if (this.msdsUploadMode && !this.files2.length) this.msdsUploadMode = false;
    },
    // FileUpload 일반 안내(형식/중복/삭제 선택 등) — 네이티브 alert 대신 스타일 팝업
    onUploadNotify(msg) {
      this.openPopup(msg, false);
    },
    // COA 파일 삭제 요청 — 이미 DB 저장된 파일(fromServer)이면 '저장해야 반영' 안내, 신규 파일이면 단순 확인. 목록에서만 제거(스테이징), 실제 삭제는 하단 [저장].
    onCoaDeleteRequest(payload) {
      const msg = payload && payload.hasServer ? '현재 COA 문서를 삭제하시겠습니까?<br>(하단 [저장]을 눌러야 실제 삭제됩니다)' : '선택한 COA 파일을 삭제하시겠습니까?';
      this.openPopup(msg, true, () => {
        if (this.$refs.upload1) this.$refs.upload1.performDelete();
      });
    },
    // 양산용 MSDS 삭제 요청 — 확인 팝업 → 목록에서만 제거(스테이징). 실제 반영은 하단 [저장], [취소] 시 원복.
    onMsdsDeleteRequest(payload) {
      const msg = payload && payload.hasServer ? '현재 MSDS 문서를 삭제하시겠습니까?<br>(하단 [저장]을 눌러야 실제 삭제됩니다)' : '선택한 MSDS 파일을 삭제하시겠습니까?';
      this.openPopup(msg, true, () => {
        if (this.$refs.upload2) this.$refs.upload2.performDelete();
      });
    },
    // 양산용 파일 목록 변경(스테이징) — files2 는 update:files 로 이미 갱신됨. 실제 DB 반영은 하단 [저장](saveTotalCoaDetail).
    onMsdsProductionDelete() {
      /* no-op: 저장 시 files2 로 반영, 취소 시 loadData 로 원복 */
    },
    save() {
      this.openPopup('저장하시겠습니까?', true, this.saveExec);
    },
    async saveExec() {
      try {
        const frm = new FormData();

        // 1. COA 파일 추가 (위치 보존을 위해 인덱스별로 키 부여)
        this.files1.forEach((file, index) => {
          if (!file.fromServer) {
            frm.append(`coaPdfFile${index + 1}`, file);
          }
        });

        // 2. MSDS 파일 추가 (위치 보존을 위해 인덱스별로 키 부여)
        this.files2.forEach((file, index) => {
          if (!file.fromServer) {
            frm.append(`msdsFile${index + 1}`, file);
          }
        });

        // 3. 현재 화면의 파일 리스트 (빈 자리는 null로 채워 항상 5개 유지)
        const coaFileNames = Array(5).fill(null);
        this.files1.forEach((f, i) => {
          if (i < 5) coaFileNames[i] = f.name;
        });

        const msdsFileNames = Array(5).fill(null);
        this.files2.forEach((f, i) => {
          if (i < 5) msdsFileNames[i] = f.name;
        });

        // 4. 그리드 데이터 및 상세 정보 구성
        const dt = this.$refs.grid.getJsonAllRow();
        const sampleDetail = makeCOASpec(dt, this.data.lotNo, this.data.code);

        const info = {
          idx: this.data.idx,
          memberId: this.id,
          lotNo: this.data.lotNo,
          coaFileNames: coaFileNames,
          msdsFileNames: msdsFileNames,
          results: sampleDetail,
          pt_cd: this.param.pt_cd,
          coa_mail_enabled_yn: this.param.coa_mail_enabled_yn,
          msds_mail_enabled_yn: this.param.msds_mail_enabled_yn,
          out_due_date: this.param.out_due_date,
        };

        // 5. JSON 데이터를 문자열로 변환하여 추가
        frm.append('info', JSON.stringify(info));

        // 6. 통합 API 호출 (단 한 번의 요청으로 모든 처리 완료)
        await saveTotalCoaDetail(frm);

        // 7. 스테이징된 자동생성 MSDS/LOC 삭제를 여기서 실제 반영 (순차 호출)
        if (this.msdsDeletePending && this.issuedMsds.length) {
          await deleteIssuedDoc(this.issuedMsds[0].id, this.id);
        }
        if (this.locDeletePending && this.issuedLoc.length) {
          await deleteIssuedDoc(this.issuedLoc[0].id, this.id);
        }
        this.msdsDeletePending = false;
        this.locDeletePending = false;
        // 저장 후 카드 최신화(삭제·양산업로드 상호배제 반영) → '저장되었습니다' 팝업 뒤에 옛 자동생성 문서가 남지 않도록
        await this.reloadIssuedMsds();
        await this.reloadIssuedLoc();

        this.openPopup(`저장되었습니다`, false, () => {
          this.REMOVE_SELECT_MENU('coaDetail');
          this.SET_SELECT_MENU_TAB_BY_CODE('COMGMT');
        });
      } catch (error) {
        console.error('Save error:', error);
        this.openPopup(`관리자에게 문의하세요 :${error}`);
      }
    },
    // 배지 목록 — '재발행'과 '자동발행/수정본'은 겹칠 수 있어 배열로 반환한다. (기획 확정 2026-07-31)
    //   배지 두 축: [재발행] = 발행 직전 현재문서가 있었나(없으면 최초 발행이라 배지 없음)
    //               [자동발행|수정본] = 미리보기에서 손댔나(안 고쳤으면 자동발행, 고쳤으면 수정본)
    //   auto          = 자동발행        : 문서 없을 때 자동생성 → 미리보기에서 수정 없이 저장
    //   auto_edited   = 수정본          : 문서 없을 때 자동생성 → 미리보기에서 수정 후 저장
    //   reissue       = 재발행+자동발행 : 문서 있을 때 [재발행] → 수정 없이 저장
    //   reissue_edited= 재발행+수정본   : 문서 있을 때 [수정], 또는 [재발행] 미리보기 안에서 수정
    //   (양산용 업로드는 Coalist.msdspdf_path 로 가므로 여기 대상이 아님. 나중에 COA/양산파일까지
    //    issued_document 로 통합하면 origin='upload' 분기를 추가할 것)
    // 색은 CSS(.doc-badge.{cls}) 담당: 재발행만 노랑, 나머지는 회색
    originBadges(origin) {
      const reissue = !!origin && origin.indexOf('reissue') === 0; // 발행 직전 현재문서가 있었나
      const edited = !!origin && origin.indexOf('_edited') > 0; // 미리보기에서 수정했나
      const badges = [];
      if (reissue) badges.push({ cls: 'reissue', label: '재발행' });
      badges.push(edited ? { cls: 'edited', label: '수정본' } : { cls: 'auto', label: '자동발행' });
      return badges;
    },
    // 양산용 업로드 시작 — 전용 파일창을 먼저 연다(취소 시 빈상태 유지). 파일 선택 후에만 업로드 모드 전환.
    startMsdsUpload() {
      if (this.$refs.msdsFileInput) this.$refs.msdsFileInput.click();
    },
    // 파일창에서 파일 선택됨 → 업로드 모드 전환 + FileUpload 에 전달(PDF검증·최대5)
    onMsdsFilePicked(e) {
      const picked = Array.from((e.target && e.target.files) || []);
      e.target.value = ''; // 같은 파일 재선택 허용
      if (!picked.length) return; // 취소 시 빈상태 유지
      this.msdsUploadMode = true;
      this.$nextTick(() => {
        if (this.$refs.upload2) this.$refs.upload2.addFiles(picked);
      });
    },
    // 빈상태에 파일 드롭 — 양산용 업로드로 처리(FileUpload 노출 후 드롭 파일 전달)
    onMsdsEmptyDrop(e) {
      this.msdsDragover = false;
      if (!this.canWriteCoa) return;
      const dropped = Array.from((e.dataTransfer && e.dataTransfer.files) || []);
      if (!dropped.length) return;
      this.msdsUploadMode = true;
      this.$nextTick(() => {
        if (this.$refs.upload2) this.$refs.upload2.addFiles(dropped);
      });
    },
    // MSDS 자동 생성 — 먼저 사전검증(차단시 미리보기 안 열고 사유 표시), 통과 시 미리보기 띄움 (실제 발행은 [저장]에서)
    async generateMsds() {
      this.msdsPublishing = true;
      try {
        const pf = await this.msdsPreflight(this.data.lotNo);
        if (!pf.canPublish) {
          this.showMsdsAlert('block', pf.blocks);
          return;
        }
        this.msdsForceRegen = false; // 자동생성(빈 상태)은 마스터 생성이 기본 — 강제 해제
        this.msdsStartInEdit = false;
        this.msdsReasonForEdit = '';
        this.msdsViewOnly = false; // 생성→저장 흐름(수정/저장 노출)
        this.msdsPreviewOpen = true;
        this.emitMsdsPreview(); // [TABEDIT]
      } catch (e) {
        this.showMsdsAlert('block', (await this.msdsErrText(e, 'MSDS 검증 중 오류가 발생했습니다.')).split('\n'));
      } finally {
        this.msdsPublishing = false;
      }
    },
    // ===== [TABEDIT] 시작 — 되돌릴 때 이 메서드 삭제 =====
    // MSDS 미리보기 상태를 'MSDS 미리보기' 탭(Service.vue)으로 전달.
    // 열람/자동생성/수정/재발행 진입점이 플래그를 세팅한 뒤 호출한다.
    emitMsdsPreview() {
      this.$emit('openMsdsPreview', {
        lotNo: this.data.lotNo,
        code: this.displayCodeGrade, // 미리보기 헤더 칩 표시용(발행 파라미터는 COADetail 이 원본으로 따로 넘긴다)
        doc: this.issuedMsds[0],
        viewOnly: this.msdsViewOnly,
        preferCurrent: this.msdsPreferCurrent,
        startInEdit: this.msdsStartInEdit,
        initialReason: this.msdsReasonForEdit,
        publishing: this.msdsPublishing,
      });
    },
    // ===== [TABEDIT] 끝 =====

    // 발행된 MSDS 문서 클릭 — 인앱 미리보기(열람 전용: 다운로드+닫기만)
    viewMsdsPreview() {
      this.msdsForceRegen = false;
      this.msdsStartInEdit = false;
      this.msdsReasonForEdit = '';
      this.msdsViewOnly = true; // 문서 클릭 열람 — 수정/저장 없음
      this.msdsPreviewOpen = true;
      this.emitMsdsPreview(); // [TABEDIT]
    },
    // 미리보기 닫기(뒤로가기) — 편집 시작·재생성 플래그 초기화
    closeMsdsPreview() {
      this.msdsPreviewOpen = false;
      this.msdsStartInEdit = false;
      this.msdsReasonForEdit = '';
      this.msdsForceRegen = false;
      this.msdsViewOnly = false;
    },
    // 서버 blob 에러(422 차단 등) 본문 텍스트 추출 — 없으면 fallback (줄바꿈 유지)
    async msdsErrText(e, fallback) {
      try {
        if (e && e.response && e.response.data && typeof e.response.data.text === 'function') {
          const t = await e.response.data.text();
          if (t) return t;
        }
      } catch (_) {
        /* noop */
      }
      return fallback;
    },
    // 자동발행 사전검증 — { canPublish, blocks[], warnings[] }
    async msdsPreflight(lotNo) {
      const res = await msdsValidate(lotNo);
      const d = (res.data && res.data.data) || {};
      return { canPublish: d.canPublish === true, blocks: d.blocks || [], warnings: d.warnings || [] };
    },
    // 자동발행 알림 다이얼로그 표시 — type: 'block'(빨강, 발행실패) | 'warn'(주황, 발행후확인)
    // 각 메시지는 "원인\n조치" 형식 → 원인=빨간 박스, 조치=박스 아래 안내로 분리 표시
    showMsdsAlert(type, messages, lead) {
      const preset = type === 'warn' ? { title: '발행 후 확인 필요', color: '#c77700', headIcon: 'mdi-alert-outline', boxIcon: 'mdi-alert-circle-outline', boxClass: 'is-warn' } : { title: '자동발행 실패', color: '#c0392b', headIcon: 'mdi-close-circle-outline', boxIcon: 'mdi-alert-circle-outline', boxClass: 'is-block' };
      const causes = [];
      const actions = [];
      (messages || [])
        .filter(m => m && m.trim())
        .forEach(m => {
          const nl = m.indexOf('\n');
          if (nl >= 0) {
            causes.push(m.slice(0, nl).trim());
            const a = m.slice(nl + 1).trim();
            if (a) actions.push(a);
          } else {
            causes.push(m.trim());
          }
        });
      this.msdsAlert = { open: true, type, lead: lead || '', causes, actions, ...preset };
    },
    // 미리보기 [저장] — 확인 alert 없이 바로 저장. 사전검증(차단시 사유표시·중단) 후 msdsPublish → 목록 갱신 → 미리보기 닫기(+발행후 경고)
    async publishMsdsFromPreview() {
      this.msdsPublishing = true;
      try {
        const pf = await this.msdsPreflight(this.data.lotNo);
        if (!pf.canPublish) {
          this.showMsdsAlert('block', pf.blocks);
          return;
        }
        await msdsPublish(this.data.lotNo, this.id);
        await this.reloadIssuedMsds();
        this.msdsDeletePending = false; // 발행이 삭제를 대체
        this.msdsPreviewOpen = false;
        this.msdsStartInEdit = false;
        this.msdsForceRegen = false;
        if (pf.warnings.length) this.showMsdsAlert('warn', pf.warnings, 'MSDS가 저장되었습니다.');
        else this.showToast('MSDS가 저장되었습니다');
      } catch (e) {
        this.showMsdsAlert('block', (await this.msdsErrText(e, 'MSDS 저장에 실패했습니다.')).split('\n'));
      } finally {
        this.msdsPublishing = false;
      }
    },
    // 미리보기 편집본 [저장] — 수정한 HTML+사유 → msdsPublishEdited(PDF렌더+S3+edited 버전) → 목록 갱신 → 미리보기 닫기
    publishEditedFromPreview(payload) {
      this.openPopup('수정 내용을 저장하시겠습니까?', true, async () => {
        this.msdsPublishing = true;
        try {
          await msdsPublishEdited(this.data.lotNo, this.data.code, payload.html, payload.reason, this.id);
          await this.reloadIssuedMsds();
          this.msdsDeletePending = false; // 발행이 삭제를 대체
          this.msdsPreviewOpen = false;
          this.msdsStartInEdit = false;
          this.msdsForceRegen = false;
          this.showToast('수정본이 저장되었습니다');
        } catch (e) {
          this.showMsdsAlert('block', (await this.msdsErrText(e, '수정본 저장에 실패했습니다.')).split('\n'));
        } finally {
          this.msdsPublishing = false;
        }
      });
    },
    // issued_document 현재 MSDS(is_latest='Y') 재조회 → issuedMsds 갱신
    async reloadIssuedMsds() {
      try {
        const ir = await getIssuedDocs(this.data.lotNo, 'MSDS');
        const docs = (ir.data && ir.data.data) || [];
        this.issuedMsds = docs.map(d => ({
          id: d.id,
          version: d.version,
          origin: d.origin,
          reason: d.edit_reason || '', // 수정사유(문서행 아래 표시)
          name: d.file_path ? d.file_path.split('/').pop() : 'MSDS.pdf',
          writer: d.reg_usr_name || d.reg_usr || '',
          date: d.reg_dt ? String(d.reg_dt).replace('T', ' ').slice(0, 16) : '',
        }));
      } catch (e) {
        this.issuedMsds = [];
      }
    },
    // MSDS [수정] — 수정 사유 입력 모달을 먼저 띄움 (카드/미리보기 양쪽 진입 공통)
    editMsds() {
      this.reasonTarget = 'MSDS';
      this.reasonText = '';
      this.reasonModalOpen = true;
    },
    // LOC [수정] — 사유 모달 공용(대상만 구분)
    editLoc() {
      this.reasonTarget = 'LOC';
      this.reasonText = '';
      this.reasonModalOpen = true;
    },
    closeReasonModal() {
      this.reasonModalOpen = false;
    },
    // [수정 시작] — 사유 확정 후 미리보기를 편집모드로 시작
    startEditWithReason() {
      const r = this.reasonText.trim();
      if (!r) return;
      this.reasonModalOpen = false;
      // forceRegen 은 건드리지 않는다: 카드 [수정]이면 이미 false(현재 발행본을 불러와 수정),
      // 재발행 미리보기 안에서 [수정]이면 true 유지(마스터 재생성본을 수정) → origin=reissue_edited
      if (this.reasonTarget === 'LOC') {
        this.locReasonForEdit = r;
        this.locStartInEdit = true;
        this.locViewOnly = false;
        this.locPreviewOpen = true;
        return;
      }
      this.msdsReasonForEdit = r;
      this.msdsStartInEdit = true;
      this.msdsViewOnly = false;
      this.msdsPreviewOpen = true;
      this.emitMsdsPreview(); // [TABEDIT]
    },
    // MSDS 재발행 — 경고(확인) 모달 먼저 띄움
    republishMsds() {
      if (!this.issuedMsds.length) return;
      this.reissueTarget = 'MSDS';
      this.reissueModalOpen = true;
    },
    // 재발행 확인(MSDS/LOC 공용) — 사전검증(차단시 사유 표시) 후 미리보기(마스터 재생성본)로 이동. 실제 발행은 미리보기 [저장]에서.
    async confirmReissue() {
      if (this.reissueTarget === 'LOC') {
        this.locPublishing = true;
        try {
          const pf = await this.locPreflight(this.data.lotNo);
          if (!pf.canPublish) {
            this.reissueModalOpen = false;
            this.showMsdsAlert('block', pf.blocks);
            return;
          }
          this.reissueModalOpen = false;
          this.locForceRegen = true; // 재발행 = 현재 발행본이 아닌 마스터 재생성본을 미리보기
          this.locStartInEdit = false;
          this.locReasonForEdit = '';
          this.locViewOnly = false;
          this.locPreviewOpen = true;
        } catch (e) {
          this.reissueModalOpen = false;
          this.showMsdsAlert('block', (await this.msdsErrText(e, 'LOC 검증 중 오류가 발생했습니다.')).split('\n'));
        } finally {
          this.locPublishing = false;
        }
        return;
      }
      this.msdsPublishing = true;
      try {
        const pf = await this.msdsPreflight(this.data.lotNo);
        if (!pf.canPublish) {
          this.reissueModalOpen = false;
          this.showMsdsAlert('block', pf.blocks);
          return;
        }
        this.reissueModalOpen = false;
        this.msdsForceRegen = true; // 재발행 = 현재 발행본이 아닌 마스터 재생성본을 미리보기
        this.msdsStartInEdit = false;
        this.msdsReasonForEdit = '';
        this.msdsViewOnly = false;
        this.msdsPreviewOpen = true;
        this.emitMsdsPreview(); // [TABEDIT]
      } catch (e) {
        this.reissueModalOpen = false;
        this.showMsdsAlert('block', (await this.msdsErrText(e, 'MSDS 검증 중 오류가 발생했습니다.')).split('\n'));
      } finally {
        this.msdsPublishing = false;
      }
    },
    // 자동생성 MSDS 삭제 — 즉시 삭제가 아니라 '삭제 대기'로 스테이징(화면에서만 내림). 실제 삭제는 하단 [저장], [취소] 시 원복.
    deleteMsds() {
      if (!this.issuedMsds.length) return;
      this.openPopup(
        '현재 MSDS 발행 내역을 삭제할까요? 이 작업은 되돌릴 수 없습니다.<br>(모든 수정사항은 화면 하단 [저장] 버튼을 눌러야 최종 적용됩니다.)',
        true,
        () => {
          this.msdsDeletePending = true;
        },
        450, // 두 문장이 각각 한 줄로 떨어지도록 기본(300)보다 넓게
      );
    },
    // TODO(슬라이스4): LOC 자동발행 (룰/템플릿 확정 후)
    // LOC 자동 생성 — 먼저 사전검증(차단시 미리보기 안 열고 사유 표시), 통과 시 미리보기 (실제 발행은 [저장]에서)
    async generateLoc() {
      this.locPublishing = true;
      try {
        const pf = await this.locPreflight(this.data.lotNo);
        if (!pf.canPublish) {
          this.showMsdsAlert('block', pf.blocks);
          return;
        }
        this.locForceRegen = false;
        this.locStartInEdit = false;
        this.locReasonForEdit = '';
        this.locViewOnly = false; // 생성→저장 흐름(수정/저장 노출)
        this.locPreviewOpen = true;
      } catch (e) {
        this.showMsdsAlert('block', (await this.msdsErrText(e, 'LOC 검증 중 오류가 발생했습니다.')).split('\n'));
      } finally {
        this.locPublishing = false;
      }
    },
    // LOC 자동발행 사전검증 — { canPublish, blocks[] } (LOC은 경고 케이스 없음)
    async locPreflight(lotNo) {
      const res = await locValidate(lotNo);
      const d = (res.data && res.data.data) || {};
      return { canPublish: d.canPublish === true, blocks: d.blocks || [] };
    },
    // 발행된 LOC 문서 클릭 — 인앱 미리보기(열람 전용: 다운로드+닫기만, 수정셀 하이라이트 포함)
    viewLocPreview() {
      this.locForceRegen = false;
      this.locStartInEdit = false;
      this.locReasonForEdit = '';
      this.locViewOnly = true; // 문서 클릭 열람 — 수정/저장 없음
      this.locPreviewOpen = true;
    },
    // LOC 재발행 — MSDS 와 동일하게 경고(확인) 모달 먼저 띄움 (확인 시 confirmReissue 에서 사전검증→미리보기)
    republishLoc() {
      if (!this.issuedLoc.length) return;
      this.reissueTarget = 'LOC';
      this.reissueModalOpen = true;
    },
    closeLocPreview() {
      this.locPreviewOpen = false;
      this.locStartInEdit = false;
      this.locReasonForEdit = '';
      this.locForceRegen = false;
      this.locViewOnly = false;
    },
    // 미리보기 [저장] — 확인 alert 없이 바로 마스터 생성본을 발행(auto, 재발행 흐름이면 reissue)
    async publishLocFromPreview() {
      this.locPublishing = true;
      try {
        const pf = await this.locPreflight(this.data.lotNo);
        if (!pf.canPublish) {
          this.showMsdsAlert('block', pf.blocks);
          return;
        }
        await locPublish(this.data.lotNo, this.id);
        await this.reloadIssuedLoc();
        this.locDeletePending = false; // 발행이 삭제를 대체
        this.locPreviewOpen = false;
        this.locStartInEdit = false;
        this.locForceRegen = false;
        this.showToast('LOC가 저장되었습니다');
      } catch (e) {
        this.showMsdsAlert('block', (await this.msdsErrText(e, 'LOC 저장에 실패했습니다.')).split('\n'));
      } finally {
        this.locPublishing = false;
      }
    },
    // 미리보기 편집본 [저장] — 수정한 HTML+사유 → edited 버전으로 저장(다음 조회 시 이 HTML을 불러옴)
    publishEditedLocFromPreview(payload) {
      this.openPopup('수정 내용을 저장하시겠습니까?', true, async () => {
        this.locPublishing = true;
        try {
          await locPublishEdited(this.data.lotNo, this.data.code, payload.html, payload.reason, this.id);
          await this.reloadIssuedLoc();
          this.locDeletePending = false; // 발행이 삭제를 대체
          this.locPreviewOpen = false;
          this.locStartInEdit = false;
          this.locForceRegen = false;
          this.showToast('수정본이 저장되었습니다');
        } catch (e) {
          this.openPopup(await this.msdsErrText(e, '수정본 저장에 실패했습니다.'), false);
        } finally {
          this.locPublishing = false;
        }
      });
    },
    // issued_document 현재 LOC(is_latest='Y') 재조회
    async reloadIssuedLoc() {
      try {
        const ir = await getIssuedDocs(this.data.lotNo, 'LOC');
        const docs = (ir.data && ir.data.data) || [];
        this.issuedLoc = docs.map(d => ({
          id: d.id,
          version: d.version,
          origin: d.origin,
          reason: d.edit_reason || '', // 수정사유(문서행 아래 표시)
          name: d.file_path ? d.file_path.split('/').pop() : 'LOC.pdf',
          writer: d.reg_usr_name || d.reg_usr || '',
          date: d.reg_dt ? String(d.reg_dt).replace('T', ' ').slice(0, 16) : '',
        }));
      } catch (e) {
        this.issuedLoc = [];
      }
    },
    // 자동생성 LOC 삭제 — MSDS 와 동일하게 '삭제 대기'로 스테이징(화면에서만 내림). 실제 삭제는 하단 [저장], [취소] 시 원복.
    deleteLoc() {
      if (!this.issuedLoc.length) return;
      this.openPopup(
        '현재 LOC 발행 내역을 삭제할까요? 이 작업은 되돌릴 수 없습니다.<br>(모든 수정사항은 화면 하단 [저장] 버튼을 눌러야 최종 적용됩니다.)',
        true,
        () => {
          this.locDeletePending = true;
        },
        450, // 두 문장이 각각 한 줄로 떨어지도록 기본(300)보다 넓게
      );
    },
    // 발행문서 PDF 다운로드(저장)
    downloadIssued(doc) {
      downloadIssuedDoc(doc.id, doc.name);
    },
    // 발행문서(issued_document) PDF를 새 탭 미리보기(파일명 클릭)
    async viewIssued(id) {
      const win = window.open('', '_blank');
      try {
        const res = await getIssuedDocFile(id);
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        if (win) win.location.href = url;
        else window.open(url, '_blank');
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      } catch (e) {
        if (win) win.close();
        this.openPopup('문서를 불러오지 못했습니다.', false);
      }
    },
    read() {},
  },
  mounted() {
    this.id = this.$store.state.member.userInfo.memberId;
    this.loadData();
  },
  beforeDestroy() {
    if (this.toastTimer) clearTimeout(this.toastTimer);
  },
  components: {
    RealGrid,
    SetPopup,
    FileUpload,
    MsdsPreview,
  },
};
</script>
<style lang="scss">
/* 저장 성공 토스트 — 흰 카드 + 초록 좌측보더 + 체크아이콘, 화면 중앙, 2.8초 자동 사라짐 */
.save-toast {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border-left: 4px solid #2e7d46;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  padding: 14px 22px 14px 16px;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}
.save-toast__icon {
  color: #2e7d46 !important;
}
.save-toast__text {
  font-weight: 500;
}
.save-toast-fade-enter-active,
.save-toast-fade-leave-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}
.save-toast-fade-enter,
.save-toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.96);
}

/* MSDS 추가 수정 사항 (납품일보 연동 · 읽기 전용) */
.msds-note-panel {
  width: 98%;
  margin: 18px auto 0;
}
.msds-note-head {
  display: flex;
  align-items: center;
  gap: 8px;
  border-left: 4px solid #17853a;
  padding-left: 8px;
  margin-bottom: 8px;
}
.msds-note-h {
  font-size: 15px;
  font-weight: 700;
  color: #262626;
}
.msds-note-sub {
  font-size: 12px;
  color: #999;
}
.msds-note-box {
  background: #fdfceb;
  border: 1px solid #ece7c0;
  border-radius: 6px;
  padding: 14px 18px;
}
.msds-note-box ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.msds-note-box li {
  position: relative;
  padding-left: 14px;
  font-size: 13px;
  line-height: 1.9;
  color: #555;
}
.msds-note-box li::before {
  content: '·';
  position: absolute;
  left: 3px;
  color: #999;
}
.msds-note-label {
  font-weight: 700;
  color: #333;
}
.msds-note-label::after {
  content: ' : ';
  font-weight: 400;
  color: #999;
}
.msds-note-empty {
  margin: 0;
  font-size: 13px;
  color: #b0ab8a;
}
.coa {
  .row {
    height: 75px;
  }
}
.reason-modal {
  &__title {
    font-size: 18px;
    font-weight: bold;
    padding: 16px 20px;
  }
  &__warn {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: #fffbe6;
    border-left: 4px solid #f0c000;
    color: #7a5b00;
    font-size: 14px;
    line-height: 1.6;
    padding: 14px 16px;
    border-radius: 4px;
    margin-bottom: 18px;
    // 자동발행 차단(빨강)
    &.is-block {
      background: #fdf3f2;
      border-left-color: #c0392b;
      color: #8a2b22;
    }
    // 자동발행 경고(주황)
    &.is-warn {
      background: #fff6e9;
      border-left-color: #e08a00;
      color: #7a4d00;
    }
  }
  &__warn-icon {
    margin-top: 1px;
    flex: 0 0 auto;
  }
  &__msg {
    margin: 0 0 6px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__lead {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    color: #2e7d46;
    margin-bottom: 12px;
  }
  // 빨간 박스 아래 조치 안내
  &__guide {
    margin: -6px 2px 8px;
    p {
      display: flex;
      align-items: flex-start;
      gap: 6px;
      margin: 0 0 6px;
      font-size: 13.5px;
      line-height: 1.6;
      color: #555;
      .v-icon {
        margin-top: 2px;
        flex: 0 0 auto;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  &__label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  &__req {
    color: #d32f2f;
  }
  &__hint {
    font-weight: normal;
    font-size: 12px;
    color: #999;
  }
  &__textarea {
    width: 100%;
    min-height: 150px;
    max-height: 35vh;
    resize: vertical;
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    padding: 10px 12px;
    font-size: 14px;
    font-family: inherit;
    line-height: 1.5;
    box-sizing: border-box;
    outline: none;
    &:focus {
      border-color: #17853a;
    }
  }
  &__counter {
    text-align: right;
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
  // actions 패딩은 아래 전역 규칙(.reason-modal-dialog ...)에서 Vuetify를 이기도록 지정.
  &__bottom-space {
    height: 28px;
  }
  &__right-space {
    width: 24px;
    flex: 0 0 auto;
  }
}
.file-upload-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
}

.file-upload-column {
  width: 48%; /* 50% - some margin for better spacing */
}
/* ===== 발행 문서 자동 작성 패널 ===== */
.issue-doc-panel {
  margin: 18px 0;
}
.issue-doc-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.issue-doc-h {
  font-weight: 700;
  font-size: 15px;
}
.issue-doc-badge {
  background: #2e7d32;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 3px;
  padding: 1px 6px;
}
.issue-doc-sub {
  color: #8a93a2;
  font-size: 12px;
}
.issue-doc-cols {
  display: flex;
  gap: 16px;
}
.issue-doc-col {
  flex: 1;
  /* 내용(긴 파일명)이 칸 폭을 밀어 넓히지 못하게 고정 — 넘치는 파일명은 말줄임 처리됨 */
  min-width: 0;
  border: 1px solid #e2e6ee;
  border-radius: 6px;
  padding: 14px 16px;
  min-height: 220px;
}
.col-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 12px;
}
.col-head b {
  font-size: 16px;
}
.col-en {
  color: #6b7280;
  font-size: 12px;
}
.col-note {
  margin-left: auto;
  color: #9aa3b2;
  font-size: 11px;
}
.doc-card {
  display: flex;
  flex-direction: column;
}
.doc-box {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 10px 12px;
  background: #fff;
}
.doc-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
}
/* 배지 색 규칙: 회색 = 자동생성/수정본/업로드, 노랑 = 재발행 */
.doc-badge {
  font-size: 11px;
  border-radius: 3px;
  padding: 1px 6px;
  background: #f0f0f0;
  color: #555;
  /* 배지는 항상 1줄 고정폭 — 공간이 모자라면 배지가 아니라 파일명이 말줄임된다 */
  white-space: nowrap;
  flex-shrink: 0;
}
.doc-badge.reissue {
  background: #fff3e0;
  color: #b45309;
}
/* 수정사유 — 문서행 아래 한 줄(길면 말줄임, 전체는 title 툴팁) */
.doc-item + .doc-item {
  margin-top: 6px;
}
.doc-reason {
  margin-top: 2px;
  padding-left: 2px;
  font-size: 12px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 라벨은 배경/테두리 없이 볼드만 (현업 요청) */
.doc-reason__label {
  font-weight: 700;
  color: #6b7280;
}
.doc-name {
  color: #2563eb;
  cursor: pointer;
  text-decoration: none;
  /* 한 줄 초과분은 말줄임(…) — 전체 파일명은 title 툴팁·다운로드로 확인 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.doc-name:hover {
  text-decoration: underline;
}
/* 파일명 아래 줄에 표시 (파일명이 한 줄을 온전히 쓰도록) */
.doc-meta {
  color: #9aa3b2;
  font-size: 12px;
  white-space: nowrap;
  margin-top: 2px;
}
.doc-actions {
  display: flex;
  gap: 6px;
  margin-top: 8px;
}
.doc-actions .doc-del {
  margin-left: auto;
  color: #c0392b;
}
/* 수정/재발행/다운로드/삭제 버튼: 네모(기본 모서리) + 테두리 연하게(취소 버튼과 동일 #d9d9d9) */
.doc-actions .v-btn {
  border-color: #d9d9d9 !important;
}
/* COA(FileUpload drop-area) · MSDS · LOC 빈상태 박스 통일 — 점선 박스 + 중앙 정렬 */
.msds-empty,
.loc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 98%;
  min-height: 190px;
  color: #9aa3b2;
  font-size: 13px;
  border: 1px dashed #bababa;
  background: #f9f9f9;
}
.msds-empty.is-dragover {
  border: 2px solid #73c076;
}
/* COA FileUpload 의 빈 헤더는 접되(빈 상태 상단 정렬), 버튼-박스 사이 여백은 MSDS와 동일하게 5px 유지 */
.coa-upload .header {
  height: auto;
  min-height: 0;
  margin-bottom: 5px;
}
.coa-upload .header h4 {
  display: none;
}
.msds-empty-actions {
  display: flex;
  gap: 8px;
}
/* 양산용 업로드(State3): 파일 개수와 무관하게 칸 높이 고정, 리스트는 내부 스크롤 (FileUpload 미변경) */
.msds-upload .file-upload {
  height: 100%;
}
.msds-upload .drop-area,
.msds-upload .file-list-container {
  height: auto !important;
  flex: 1;
  min-height: 0;
}
/* COA 업로드도 MSDS와 동일: 전체 높이 고정 → 헤더(버튼) 생기면 그만큼 박스가 flex로 줄어 총 높이 유지 */
.coa-upload {
  display: flex;
  flex-direction: column;
}
.coa-upload .file-upload {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.coa-upload .drop-area,
.coa-upload .file-list-container {
  height: auto !important;
  flex: 1;
  min-height: 0;
}
.btn-box {
  margin-bottom: 20px;
}
/* 수정 사유 모달: 상단 고정 — 세로 중앙정렬 시 창 높이가 낮으면 하단 버튼(취소/수정 시작)이
   화면 밖으로 잘리므로, teleport된 .v-dialog__content를 상단정렬로 바꿔 모달을 위에 붙인다.
   (content-class="reason-modal-dialog" → .v-dialog__content 에 부착) */
.reason-modal-dialog.v-dialog__content {
  align-items: flex-start;
}
.reason-modal-dialog > .v-dialog {
  margin-top: 6vh;
}
/* Vuetify 기본 `.v-dialog > .v-card > .v-card__actions {padding:8px 16px}`(특이도 0,3,0)를
   확실히 이기도록 (0,4,0)으로 올려 버튼 아래·오른쪽 여백 확보 */
.reason-modal-dialog .reason-modal.v-card > .v-card__actions {
  padding: 12px 24px 32px;
}
</style>
